import { createSlice } from "@reduxjs/toolkit";
import { AddChalan, UpdateChalan, DeleteChalan, GetChalanListByShop, GetChalanItems, GetChalanDetail } from "services/chalan/chalan.service";
import { toast } from 'react-toastify';
// import { act } from "react-dom/test-utils";


export const chalanListByShopSlice = createSlice({
  name: "chalanList",
  initialState: {
    chalanList: [],
    chalanListLoading: false,
    chalanListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetChalanListByShop.pending, (state) => {
      state.workOrderListLoading = true
    });

    builder.addCase(GetChalanListByShop.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Chalan List Promise resolved 👌');

      state.chalanList = action.payload
      state.chalanListLoading = false
      state.chalanListError = null
    });

    builder.addCase(GetChalanListByShop.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Chalan List Promise rejected 🤯 😣')

      state.chalanListLoading = false
      state.chalanListError = action.error?.message
    });
  },
});

export const chalanAddSlice = createSlice({
  name: "chalanAdd",
  initialState: {
    chalanAdd: {},
    chalanAddLoading: false,
    chalanAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddChalan.pending, (state) => {
      // toast.loading('We are adding the chalan 🤯')
      state.chalanAddLoading = true
    });

    builder.addCase(AddChalan.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New chalan added successfully 👌');

      state.chalanAdd = action.payload
      state.chalanAddLoading = false
      state.chalanAddError = null
    });

    builder.addCase(AddChalan.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the chalan 😣")

      state.chalanAddLoading = false
      state.chalanAddError = action.error?.message
      toast.error(action.error?.message)
    });
  },
});

export const chalanUpdateSlice = createSlice({
  name: "chalanUpdate",
  initialState: {
    chalanUpdate: {},
    chalanUpdateLoading: false,
    chalanUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateChalan.pending, (state) => {
      // toast.loading('We are updating the chalan 🤯')
      state.chalanUpdateLoading = true
    });

    builder.addCase(UpdateChalan.fulfilled, (state, action) => {
      toast.dismiss();
      if(action?.payload?.warning.length > 0){
        alert(`Receive quantity can not less then sold quantity for these items: ${action?.payload?.warning}`)
        toast.warning('Receive quantity can not less then sold quantity')
      }else{
        toast.success('Chalan update successfully 👌');
      }

      state.chalanUpdate = action.payload
      state.chalanUpdateLoading = false
      state.chalanUpdateError = null
    });

    builder.addCase(UpdateChalan.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the chalan 😣")

      state.chalanUpdateLoading = false
      state.chalanUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const deleteChalanSlice = createSlice({
  name: "deleteChalan",
  initialState: {
    deleteChalan: {},
    deleteChalanLoading: false,
    deleteChalanError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {

    builder.addCase(DeleteChalan.fulfilled, (state, action) => {
      state.deleteChalan = action.payload

      if(action?.payload?.message?.length > 0){
        alert(action?.payload?.message)
        toast.warning('Some items already sold from this chalan. We can delete this chalan')
      }else{
        toast.success('Chalan delete successfully 👌');
      }
    });
  },
});


export const chalanItemsSlice = createSlice({
  name: "chalanItems",
  initialState: {
    chalanItems: [],
    chalanItemsLoading: false,
    chalanItemsError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetChalanItems.pending, (state) => {
      state.chalanItemsLoading = true
    });

    builder.addCase(GetChalanItems.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved for chalam items👌');

      state.chalanItems = action.payload
      state.chalanItemsLoading = false
      state.chalanItemsError = null
    });

    builder.addCase(GetChalanItems.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected for chalam items 🤯 😣')

      state.chalanItemsLoading = false
      state.chalanItemsError = action.error?.message
    });
  },
});


export const chalanDetailSlice = createSlice({
  name: "chalanDetail",
  initialState: {
    chalanDetail: [],
    chalanDetailLoading: false,
    chalanDetailError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetChalanDetail.pending, (state) => {
      state.chalanDetailLoading = true
    });

    builder.addCase(GetChalanDetail.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved for chalam detail👌');

      state.chalanDetail = action.payload
      state.chalanDetailLoading = false
      state.chalanDetailError = null
    });

    builder.addCase(GetChalanDetail.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected for chalam detail 🤯 😣')

      state.chalanDetailLoading = false
      state.chalanDetailError = action.error?.message
    });
  },
});


